export const environment = {
  production: true,
  name: 'prod',
  version: '2610.26.699.0',
  featureFlag: false
};
